export default __webpack_public_path__ + "static/media/shreyansh.3ebf29f7.png";